import React from 'react';
import PropTypes from 'prop-types';
import { Container, H2, Image, MarkdownWrapper } from 'components/atoms';

import './SGPHeader.scss';

export function SGPHeader({ image, imageAlt, title, description }) {
	return (
		<div className="sgp-header">
			<Container>
				<div className="sgp-header__inner">
					<div className="sgp-header__image-group">
						<div className="sgp-header__image-frame sgp-header__image-frame--back" />
						<div className="sgp-header__image-frame sgp-header__image-frame--middle" />
						<Image
							src={image}
							alt={imageAlt || title}
							className="sgp-header__image"
						/>
					</div>
					<div className="sgp-header__text">
						<H2
							className="sgp-header__title"
							color="white"
						>
							{title}
						</H2>
						<MarkdownWrapper
							content={[{ value: description }]}
							componentProps={{
								color: 'white',
								className: 'sgp-header__description',
							}}
						/>
					</div>
				</div>
			</Container>
		</div>
	);
}

SGPHeader.propTypes = {
	image: PropTypes.string.isRequired,
	imageAlt: PropTypes.string,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
};

SGPHeader.defaultProps = {
	imageAlt: '',
};

export default SGPHeader;
